<template>
  <div class="personal-page">
    <Nav style="margin-bottom: 94px"></Nav>
    <div class="personal-modal">
      <div class="modal-left">
        <div class="user-detail">
          <img class="user-img" :src="avatar" alt="" />
          <div class="user-name">{{ userInfo.userName }}</div>
          <div class="user-code">
            编号：{{ userInfo.extraProperties.UserCode }}
          </div>
        </div>
        <div class="left-line"></div>
        <div class="left-nav">
          <template v-for="(item, index) in navList">
            <div
              class="nav-item"
              :class="[active == item.type && 'active']"
              @click="activeModal(item.type)"
              :key="index"
              v-if="
                (item.type == ActiveType.backstage && auth) ||
                item.type != ActiveType.backstage
              "
            >
              <img v-if="item.img" :src="item.img" style="margin-right: 20px" alt="" />
              <i  v-if="item.elIcon" :class="item.elIcon" style="margin-right: 20px;font-size: 28px;"></i>
              <span  :class="[active == item.type && 'color: #1fa3ff;']">
                {{ item.name }}
              </span>
            </div>
          </template>
        </div>
      </div>
      <div class="modal-center"></div>
      <div class="modal-right">
          <!-- <configModal
      v-if="active == ActiveType.config"
      :avatar="avatar"
      :headDialogVisible="headDialogVisible"
    ></configModal> -->
          <div class="config-modal" v-if="active == ActiveType.config">
              <div class="config-head">
                  <img class="user-headImg" v-if="avatar" :src="avatar" />
                  <!-- <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :on-change="handleChange"
              :auto-upload="false"
            > -->
                  <div class="file-btn" @click="headDialogVisible = true">
                      <span style="margin-right: 8px"> 修改头像 </span>
                      <img src="@/assets/list/arrows-right.png" alt="" />
                  </div>
                  <!-- </el-upload> -->
              </div>
              <div class="config-main">
                  <div class="main-title">基本资料</div>
                  <el-form label-position="left"
                           label-width="80px"
                           :model="userInfo"
                           :rules="rules">
                      <el-form-item label="编号">
                          <el-input v-model="userInfo.extraProperties.UserCode"></el-input>
                      </el-form-item>
                      <el-form-item label="登录名">
                          <el-input v-model="userInfo.userName"></el-input>
                      </el-form-item>
                      <el-form-item label="姓名">
                          <el-input v-model="userInfo.name"></el-input>
                      </el-form-item>
                      <el-form-item label="性别">
                          <!-- <el-input v-model="userInfo.type"></el-input> -->
                          <el-radio v-model="userInfo.extraProperties.Sex" label="male">男</el-radio>
                          <el-radio v-model="userInfo.extraProperties.Sex" label="female">女</el-radio>
                      </el-form-item>
                      <el-form-item label="手机">
                          <!-- prop="phone" -->
                          <el-input v-model="userInfo.extraProperties.MobilePhone"></el-input>
                      </el-form-item>
                      <el-form-item label="邮箱">
                          <el-input v-model="userInfo.email"></el-input>
                      </el-form-item>
                      <el-form-item>
                          <el-button style="width: 157px; height: 40px"
                                     type="primary"
                                     round
                                     :loading="loading"
                                     @click="onSubmit">保存</el-button>
                      </el-form-item>
                  </el-form>
              </div>
          </div>
          <!-- 账户安全 -->
          <div v-if="active == ActiveType.password">
              <div class="main-header">
                  <div class="head-title">修改账户密码</div>
                  <div class="head-line"></div>

              </div>
              <div class="config-modal config-main" style="width:600px">

                  <el-form label-position="left"
                           label-width="120px"
                           :model="password" ref="passForm"
                           :rules="rulesPass">
                      <el-form-item label="旧密码" prop="oldPassword">
                          <el-input v-model="password.oldPassword" type="password" autocomplete="off" placeholder="请输入旧密码"></el-input>
                      </el-form-item>
                      <el-form-item label="新密码" prop="newPass">
                          <el-input v-model="password.newPass" type="password" autocomplete="off" placeholder="请输入新密码"></el-input>
                      </el-form-item>
                      <el-form-item label="确认新密码" prop="checkPass">
                          <el-input v-model="password.checkPass" type="password" autocomplete="off" placeholder="请再次输入新密码"></el-input>
                      </el-form-item>
                      <el-form-item>
                          <el-button style="width: 157px; height: 40px"
                                     type="primary"
                                     round
                                     :loading="loading"
                                     @click="onUpdatePassSubmit">保存</el-button>
                      </el-form-item>
                  </el-form>
              </div>
          </div>
          <recordModal v-if="active == ActiveType.record"></recordModal>
          <messageModal v-if="active == ActiveType.message"></messageModal>
          
      </div>
    </div>
    <el-dialog
      title="修改头像"
      :visible.sync="headDialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="629px"
      :before-close="handleClose"
    >
      <div
        slot="title"
        class="dialog-header"
        style="
          height: 77px;
          border-bottom: 1px solid #eeeeee;
          padding-left: 58px;
        "
      >
        <span
          style="
            font-size: 20px;
            font-weight: 600;
            text-align: left;
            color: #000000;
            line-height: 77px;
          "
          >修改头像</span
        >
      </div>
      <div class="upload-modal">
        <div class="upload-head">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :on-change="handleChange"
            :auto-upload="false"
          >
            <div class="left">选择要上传的图片</div>
          </el-upload>
        </div>
        <div class="upload-main">
          <div class="left">
            <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :on-change="handleChange"
              :auto-upload="false"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="right">
            <div>
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <div v-else class="no-img"></div>
              <div class="tips">头像预览</div>
            </div>
            <div class="submit-btn" @click="upload">确定</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

import Nav from "@/components/nav.vue";
import configModal from "./components/configModal.vue";
import recordModal from "./components/recordModal.vue";
import messageModal from "./components/messageModal.vue";


const pointImg = require("../../assets/home/point.png");
const personalImg = require("../../assets/home/personal-center.png");
const recordImg = require("../../assets/home/record.png");
const messageImg = require("../../assets/home/message-icon.png");
const configImg = require("../../assets/home/config-icon.png");

const passwordImg = require("../../assets/home/password.png");

const ActiveType = {
  // personal: 1, // 个人中心
    //dataPanel: 2, // 数据面板
    record: 2, // 我的档案
    //points: 4,//积分商城
    //certs: 5,//我的证书
    message: 1, // 我的消息
    config: 3, // 账号设置
  //  backstage: 8, // 后台管理
    password: 4 // 账户安全
    //myCourseCollect:10 //课程收藏
};
import Api from "@/api/user";
let validatePhone = (rule, value, callback) => {
  /*console.log(rule);
      console.log(value);
      console.log(callback);*/
  if (!value) {
    callback(new Error("手机号不能为空！"));
  }
  //使用正则表达式进行验证手机号码
  if (!/^1[3456789]\d{9}$/.test(value)) {
    callback(new Error("手机号不正确！"));
  }
};
export default {
  components: {
    Nav,
    configModal,
    recordModal,
    messageModal,
    
  },
        data() {
          
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入新密码'));
                } else {
                    //console.warn(/[0-9]/.test(value));
                    if (this.passData.requireDigit == true) {
                        let passwordReg = /[0-9]/;
                        if (!passwordReg.test(value)) {
                            callback(new Error('密码必须包含数字'));
                        }
                    }
                    if (this.passData.requireUppercase == true) {
                        let passwordReg = /[A-Z]/;
                        if (!passwordReg.test(value)) {

                            callback(new Error('密码必须包含大写字母'));
                        }
                    }
                    if (this.passData.requireLowercase == true) {
                        let passwordReg = /[a-z]/;
                        if (!passwordReg.test(value)) {
                            callback(new Error('密码必须包含小写字母'));
                        }
                    }
                    if (this.passData.requireLowercase == true) {
                        let passwordReg = new RegExp(
                            "[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]"
                        );
                        if (!passwordReg.test(value)) {
                            callback(new Error('密码必须包含特殊符号'));
                        }
                    }
                    if (
                        value.length < this.passData.requiredLength ||
                        value.length > 10000
                    ) {
                        callback(new Error('密码至少为6个字符'));
                    }
                    if (this.password.checkPass !== '') {
                                            
                        this.$refs.passForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入新密码'));
                } else if (value !== this.password.newPass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
      return {
          loading: false,
          rules: {
              phone: [{ validator: validatePhone, trigger: "blur" }],
          },
          rulesPass: {
              newPass: [
                  { required: true,validator: validatePass, trigger: 'blur' }
              ],
              checkPass: [
                  { required: true,validator: validatePass2, trigger: 'blur' }
              ],
              oldPassword: [
                  { required: true, message: '请输入旧密码',  trigger: 'blur' }
              ]
          },
          password: {
              oldPassword: "",
              newPass: "",
              checkPass:""
          },
          passData: {},
      headDialogVisible: false,
      auth: JSON.parse(sessionStorage.getItem("auth")),
      ActiveType: ActiveType,
      loading: false,
      avatar: "",
      active: ActiveType.config,
      userInfo: {
        extraProperties: {},
      },
      imageUrl: "",

      navList: [
        // { name: "个人中心", img: personalImg, type: ActiveType.personal },
          //{ name: "数据面板", img: dataPanelImg, type: ActiveType.dataPanel },
          { name: "我的档案", img: recordImg, type: ActiveType.record },
          /*{ name: "积分商城", img: pointImg, type: ActiveType.points },*/
          /*{ name: "我的证书", img: certImg, type: ActiveType.certs },*/
          //{ name: "课程收藏", img:"",elIcon: "el-icon-star-on", type: ActiveType.myCourseCollect },
          { name: "我的消息", img: messageImg, type: ActiveType.message },
          { name: "账号设置", img: configImg, type: ActiveType.config },
          { name: "账号安全", img: passwordImg, type: ActiveType.password },
      /*  { name: "后台管理", img: backstageImg, type: ActiveType.backstage },*/
      ],
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    handleChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      } else {
        //console.warn(file.raw);
        let formData = new FormData();
        this.formData = formData;
        formData.append("file", file.raw);
/*        console.warn(this.formData);*/
        this.imageUrl = URL.createObjectURL(file.raw);
 /*       console.warn("imageUrl", this.imageUrl);*/
        this.$forceUpdate();
      }
      return isLt2M;
    },
    activeModal(type) {
      this.active = type;
      this.$forceUpdate();
    },
    upload() {
      let fileRelationId = "";
      if (sessionStorage.getItem("userId")) {
        fileRelationId = sessionStorage.getItem("userId");
      }
      axios
        .post(
          `/api/app/file/upload-file-system?fileTypeCode=user&fileRelationId=${fileRelationId}`,
          this.formData
        )
        .then((res) => {
         // console.warn(res);
          this.avatar = this.imageUrl;
          let params = res.data;
         // console.warn("res.data", res);
          axios
            .post(
              `/api/base/user/avatar/${fileRelationId}?blobName=${params.blobName}`
            )
            .then((res) => {
              if (res) {
                this.$message.success("照片上传成功");
                this.getUserInfo();
                this.headDialogVisible = false;
              } else {
                this.$message.success("照片上传失败，请重新上传或联系管理员");
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    getUserInfo() {
      Api.getUserInfo(this.userInfo.id)
        .then((result) => {
          sessionStorage.setItem("userInfo", JSON.stringify(result.data));
          this.userInfo = result.data;
          // this.$success('上传成功');
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    onSubmit() {
      this.loading = true;
      let params = {
        userName: this.userInfo.userName,
        name: this.userInfo.name,
        email: this.userInfo.email,
        mobilephone: this.userInfo.extraProperties.MobilePhone,
        sex: this.userInfo.extraProperties.Sex,
      };
      Api.updateUserInfo(this.userInfo.id, params)
        .then((res) => {
          //console.warn(res);
          this.getUserInfo();
          this.loading = false;
        })
        .catch((err) => {});
      this.loading = false;
      },
      onUpdatePassSubmit() {
          this.$refs["passForm"].validate((valid) => {
              if (valid) {
                  //修改密码
                  let params = {
                      userName: this.userInfo.userName,
                      password: this.password.newPass,
                      email: this.userInfo.email,
                  };
                  //验证密码
                  axios.get(`/api/base/user/compare-password?userId=${this.userInfo.id}&oldPassword=${this.password.oldPassword}`)
                      .then((res) => {

                          if (res.data) {
                              //修改用户信息
                              axios.post(`/api/base/user/updatebyuser/${this.userInfo.id}`, params)
                                  .then((res) => {
                                      this.$refs["passForm"].resetFields();
                                      this.$message.success("密码修改成功!");
                                  })
                                  .catch((err) => {
                                      this.$message.error(err);
                                  });

                          } else {
                              this.$message.error("旧密码错误,请验证后重试");
                          }
                      })
                      .catch((err) => {
                          this.$message.error(err);
                      });


              } else {
                 
                  return false;
              }
          });
      },
       // 密码检查
      passwordcheck() {

          axios.get( `/api/base/user/passwordcheck`)
              .then((res) => {
                  
                  this.passData = res.data;
              })
              .catch((err) => {
                  this.$message.error(err);
              });
         
      },
  },
  created() {
    this.passwordcheck();
    if (sessionStorage.getItem("Avatar")) {
      this.avatar = sessionStorage.getItem("Avatar");
    }
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    } else {
      this.getUserInfo();
    }
    if (this.$route.query && this.$route.query.type) {
      this.active = this.$route.query.type;
    }
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        if (newVal.query.type) {
          this.active = this.$route.query.type;
        } else {
          this.listQuery.examUserListSearchBase.examName = "";
        }
        this.$forceUpdate()
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 0 !important;
  padding-left: 54px;
}
::v-deep .el-dialog {
  background: #ffffff;
  border-radius: 12px;
}
    .personal-page {
        background-image: url("../../assets/exam/exam-bg.jpg");
        background-size: cover;
        width: 100%;
        height: 100%;
        overflow-x: hidden;

        .main-header {
            padding-top: 40px;
            padding-left: 40px;
            width: 989px;
            margin: 0 auto;
            // display: flex;
            margin-bottom: 18px;
            // justify-content: space-between;
            // align-items: center;
            .head-title {
                width: 100%;
                font-size: 20px;
                font-weight: 600;
                text-align: left;
                color: #000000;
                line-height: 28px;
                padding-bottom: 26px;
                //   margin-bottom: ;
            }

            .head-line {
                width: 100%;
                height: 1px;
                opacity: 0.1;
                background: #3e4294;
            }
        }

        .personal-modal {
            display: flex;
            width: 1300px;
            height: 745px;
            margin: 150px auto 0;
            background: linear-gradient( 136deg, rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.8) 100% );
            border: 1.5px dashed #ffffff;
            border-radius: 15px;
            box-shadow: 0px 2px 5.5px 0px rgba(0, 0, 0, 0.04);
            backdrop-filter: blur(8.4px);

            .modal-left {
                width: 226px;

                .user-detail {
                    padding: 44px 0 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .user-img {
                        width: 90px;
                        height: 90px;
                        border-radius: 50%;
                        object-fit: cover;
                    }

                    .user-name {
                        font-size: 20px;
                        font-weight: 600;
                        text-align: center;
                        color: #000000;
                        line-height: 28px;
                    }

                    .user-code {
                        font-size: 14px;
                        font-weight: 500;
                        text-align: center;
                        color: #999999;
                        line-height: 28px;
                    }
                }

                .left-line {
                    width: 148px;
                    height: 1px;
                    margin: 20px auto;
                    opacity: 0.1;
                    background: #3e4294;
                }

                .left-nav {
                    text-align: center;

                    .nav-item {
                        font-size: 16px;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        //   text-align: left;
                        margin-bottom: 20px;
                        color: #333333;
                        line-height: 28px;
                        cursor: pointer;

                        &.active {
                            position: relative;

                            color: #1fa3ff;
                            &::before {
                                content: "";
                                left: 0;
                                position: absolute;
                                width: 6px;
                                height: 25px;
                                background: #1fa3ff;
                            }
                        }
                    }
                }
            }

            .modal-center {
                height: 100%;
                width: 1px;
                border-left: 1px solid #3e4294;
                opacity: 0.1;
            }

            .modal-right {
                .modal-item {
                }
            }
        }

        .config-modal {
            padding: 30px 50px;



            .config-head {
                display: flex;
                flex-direction: column;
                align-items: center;


                .file-btn {
                    width: 101px;
                    height: 34px;
                    cursor: pointer;
                    margin: 12px auto;
                    background-color: #fdfefe;
                    border: 0.8px solid #979797;
                    font-size: 12px;
                    font-weight: 600;
                    color: #000000;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .user-headImg {
                    width: 130px;
                    height: 130px;
                    object-fit: cover;
                    border-radius: 50%;
                }
            }

            .config-main {

                .main-title {
                    font-size: 20px;
                    font-weight: 600;
                    text-align: left;
                    color: #000000;
                    line-height: 28px;
                    margin-bottom: 15px;
                }
            }
        }

        .dialog-heade {
            height: 77px;
        }

        .upload-modal {
            height: 461px;
            padding: 0 41px;

            .upload-head {
                margin-bottom: 20px;

                .left {
                    width: 227px;
                    height: 57px;
                    background: #f8f8f8;
                    border-radius: 2px;
                    font-size: 16px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #000000;
                    line-height: 57px;
                }
            }

            .upload-main {
                display: flex;
                justify-content: space-between;
                height: 317px;

                .left {
                    width: 352px;
                    height: 317px;

                    .avatar-uploader {
                        width: 352px;
                        height: 317px;

                        .avatar-uploader .el-upload {
                            border: 1px dashed #d9d9d9;
                            border-radius: 6px;
                            cursor: pointer;
                            position: relative;
                            overflow: hidden;
                        }

                        .avatar-uploader .el-upload:hover {
                            border-color: #409eff;
                        }

                        .avatar-uploader-icon {
                            font-size: 28px;
                            color: #8c939d;
                            width: 352px;
                            height: 317px;
                            line-height: 317px;
                            text-align: center;
                            border: 1px dashed #d9d9d9;
                            border-radius: 6px;
                        }

                        .avatar {
                            width: 352px;
                            height: 317px;
                            display: block;
                        }
                    }
                }

                .right {
                    text-align: center;
                    height: 100%;
                    width: 120px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .tips {
                        font-size: 16px;
                        font-weight: 500;
                        text-align: center;
                        color: #999999;
                        line-height: 22px;
                        margin-top: 12px;
                    }

                    .no-img {
                        width: 120px;
                        height: 120px;
                        border-radius: 50%;
                        border: 2px solid #1fa3ff;
                    }

                    img {
                        width: 120px;
                        height: 120px;
                        border-radius: 50%;
                        object-fit: cover;
                        border: 2px solid #1fa3ff;
                    }

                    .submit-btn {
                        width: 141px;
                        height: 40px;
                        background: #1fa3ff;
                        border-radius: 26px;
                        color: #ffffff;
                        line-height: 40px;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>